import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  Dimensions,
} from 'react-native';
import withLiveData from '../../../common/withLiveData';
import SingleOrderBuy from './SingleOrderBuy';
import SingleOrderBuyIM from './SingleOrderBuyIM';
import Colors from '../../../assets/Color/Colors';
import {Color, globalFontStyle} from '../../../assets';
import {TEST_API} from '../../../utils/apiUrl';
import {Button} from '../../../components/core/Button';
import {useNavigation} from '@react-navigation/native';
import FastImage from '../../../common/FastImage';
import {globalImport} from '../../../common/globalImports';
import {getLoginRoute, isMobile, showLoginModal} from '../../../utils/commonMethods';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {globalConfigurableData} from '../../../utils/globalConstant';
import {useDispatch, useSelector} from 'react-redux';
import { getSubcategoryImage } from "../../../utils/subcategoryImages";
import { defaulteventimage } from "../../../utils/images";

const dummyUserInfo = [
  {
    title: 'Predict Outcomes. Buy Yes or No',
    subtitle: "Buy Yes if you think the event will happen & No if you don't. Please note that news triggers price changes in the market",
  },
  {
    title: 'Sell Early to book profits',
    subtitle:
      'Buy & Sell positions as events become more or less likely over time.',
  },
  {
    title: 'Collect Profits on Event Settlement',
    subtitle:
      'When the outcome of the event becomes clear, the event settles and you earn 100/- for every correct share you own.',
  },
];

const UserSide = ({orderStatus, onSignUpClick, _eventInfo, live}) => {
  const [selected, setSelected] = useState({
    selectedItem: 2,
    selectedArr: [2],
  });
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const isAppLogin = useSelector(({utilReducer}) => utilReducer.isAppLogin);

  useEffect(() => {
    // Call orderStatus after successful login
    if (isAppLogin) {
      orderStatus();
    }
  }, [isAppLogin]);

  const onSelect = param => {
    selected.selectedArr.push(param);
    selected.selectedItem = param;
    setSelected({...selected});
  };

  const signUpClick = () => {
    // Close the How to Trade modal first
    orderStatus();
    // Show login modal
    showLoginModal(dispatch);
  };

  const newYCP = live?.newYCP ?? _eventInfo?.newYCP ?? 50;
  const newNCP = live?.newNCP ?? _eventInfo?.newNCP ?? 50;

  return (
    <View style={isMobile() ? {width: Dimensions.get('window').width} : {}}>
      <View
        style={{
          justifyContent: 'space-between',
          paddingHorizontal: 15,
          paddingTop: 4,
          paddingBottom: 15,
        }}>
        <View>
          <View>
            <Text
              style={{
                ...globalFontStyle.appFontTitle,
                color: globalConfigurableData.primaryTextColor1,
              }}>
              How it works
            </Text>
          </View>

          {selected?.selectedItem === 0 && (
            <View>
              <Text style={styles.userScreenHeader}>PEOPLE SENTIMENTS</Text>
              <Text
                style={
                  newYCP.toFixed(2) > newNCP.toFixed(2)
                    ? {
                        ...styles.userScreenSubHeader,
                        color: 'rgba(10, 88, 129, 1)',
                      }
                    : {
                        ...styles.userScreenSubHeader,
                        color: 'rgba(231, 93, 22, 1)',
                      }
                }>
                {newYCP.toFixed(2) > newNCP.toFixed(2)
                  ? `Yes ${parseInt(newYCP)}%`
                  : `No ${parseInt(newNCP)}%`}
              </Text>
              <FastImage
                style={{
                  width: 50,
                  height: 50,
                  marginTop: 15,
                  borderRadius: 10,
                }}
                source={{
                  uri: _eventInfo?.imageurl || 
                       getSubcategoryImage(_eventInfo?.subcategory) || 
                       defaulteventimage()
                }}
              />
              <Text
                style={{
                  ...globalFontStyle.appFontHeadingRegular,
                  color: Colors.black,
                  marginTop: 15,
                  marginBottom: 50,
                }}>
                {_eventInfo?.title}
              </Text>
              <View style={{flexDirection: 'row'}}>
                <Button
                  variant="yes"
                  onPress={() => {
                    if (typeof onSelect === 'function') {
                      onSelect(1);
                    }
                  }}
                  style={{
                    flex: 1,
                    marginRight: 5,
                    backgroundColor: Colors.tradexBlue,
                  }}
                  className="trading-button"
                >
                  Yes
                </Button>
                <Button
                  variant="no"
                  onPress={() => {
                    if (typeof onSelect === 'function') {
                      onSelect(1);
                    }
                  }}
                  style={{
                    flex: 1,
                    marginLeft: 5,
                    backgroundColor: Colors.tradexRed,
                  }}
                  className="trading-button"
                >
                  No
                </Button>
              </View>
            </View>
          )}
        </View>

        {selected?.selectedItem === 2 && (
          <View style={{paddingTop: 25}}>
            {dummyUserInfo.map((item, index) => {
              return (
                <View key={`info-${index}`} style={styles.userScreenBlk}>
                  <FormTextLabel
                    labelStyles={styles.userScreen3Title}
                    label={item.title}
                  />
                  <FormTextLabel
                    labelStyles={styles.userScreen3SubTitle}
                    label={item.subtitle}
                  />
                </View>
              );
            })}
            <Button
              variant="primary"
              onPress={() => {
                if (typeof signUpClick === 'function') {
                  signUpClick();
                }
              }}
              style={{
                flex: globalImport.isWeb ? undefined : 0,
              }}
              translate
            >
              Sign up and get 2500 Token Points
            </Button>
          </View>
        )}
        {selected?.selectedItem === 1 && (
          <View style={{paddingTop: 45, margin: -15}}>
            {_eventInfo?.is_price_editable ? (
              <SingleOrderBuy
                isDummy={true}
                eventDetails={{
                  ..._eventInfo,
                  newYCP: _eventInfo?.newYCP ? _eventInfo?.newYCP : 50,
                  newNCP: _eventInfo?.newNCP ? _eventInfo?.newNCP : 50,
                }}
                orderStatus={orderStatus}
                onClick={() => onSelect(2)}
                isLimit={true}
              />
            ) : (
              <SingleOrderBuyIM
                isDummy={true}
                eventDetails={_eventInfo}
                orderStatus={orderStatus}
                onClick={() => onSelect(2)}
                orderBookSelectedData={{callvalue: 'Y'}}
              />
            )}
          </View>
        )}
      </View>
    </View>
  );
};

const getEventId = props => props?._eventInfo?.id;
const UserSideContainer = withLiveData(getEventId)(UserSide);
export default UserSideContainer;

const styles = StyleSheet.create({
  timelineItem: {
    width: 20,
    height: 20,

    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',

    borderColor: Colors.black2,
    borderWidth: 0.5,
    borderRadius: 50,
    color: Colors.black,
    backgroundColor: Colors.bgWhite,
    textAlign: 'center',
  },
  timeLineItemSelected: {
    backgroundColor: Colors.tradexBlue,
    color: Colors.bgWhite,
  },
  timelineStroke: {
    width: 15,
    marginHorizontal: 10,
    zIndex: 1,
    height: 1,
    alignSelf: 'center',

    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  userScreenHeader: {
    ...globalFontStyle.appFontBody,
    color: Colors.lightgrey,
    marginTop: 30,
    marginBottom: 5,
  },
  userScreenSubHeader: {
    marginTop: 5,
    ...globalFontStyle.appFontMainHead,
  },
  userScreenBlk: {
    paddingBottom: 25,
    marginTop: 0,
  },
  userScreen3Title: {
    ...globalFontStyle.appFontSubHeading,
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 10,
  },
  userScreen3SubTitle: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.tertiaryTextColor1,
  },
});
